import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'tabs/home', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [guestGuard],
    children: [
      { path: 'login', loadComponent: () => import('./auth/login/login.page').then((m) => m.LoginPage) },
      { path: 'register', loadComponent: () => import('./auth/register/register.page').then((m) => m.RegisterPage) },
      {
        path: 'recover-password',
        loadComponent: () => import('./auth/recover-password/recover-password.page').then((m) => m.RecoverPasswordPage),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  {
    path: 'tabs',
    canActivate: [authGuard],
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.TABS_ROUTES),
  },
  {
    path: 'wallets/create',
    canActivate: [authGuard],
    loadComponent: () => import('./wallets/wallet-create/wallet-create.page').then((m) => m.WalletCreatePage),
  },
  {
    path: 'wallets/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./wallets/wallet-detail/wallet-detail.page').then((m) => m.WalletDetailPage),
  },
  {
    path: 'wallets/:id/send',
    canActivate: [authGuard],
    loadComponent: () => import('./wallets/send/send.page').then((m) => m.SendPage),
  },
  {
    path: 'wallets/:id/receive',
    canActivate: [authGuard],
    loadComponent: () => import('./wallets/receive/receive.page').then((m) => m.ReceivePage),
  },
  {
    path: 'chats/add',
    canActivate: [authGuard],
    loadComponent: () => import('./chats/add-contact/add-contact.page').then((m) => m.AddContactPage),
  },
  {
    path: 'chats/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./chats/chat-window/chat-window.page').then((m) => m.ChatWindowPage),
  },
  {
    path: 'blog/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./blog/blog-post/blog-post.page').then((m) => m.BlogPostPage),
  },
  {
    path: 'exchange',
    canActivate: [authGuard],
    loadComponent: () => import('./exchange/exchange.page').then((m) => m.ExchangePage),
  },
  { path: '**', redirectTo: 'tabs/home' },
];
